/**
 * @module html
 * @description HTML 相关函数
 * @author: Yawei Wang
 * @date: 2019-06-03 10:47:20
 */

/**
 * html解析
 * @function
 * @param {String} str 字符串
 * @desc html_decode => decodeHtml
 */
export var decodeHtml = function decodeHtml(str) {
  if (!str || str.length === 0) {
    return '';
  }

  return str.replace(/&amp;/g, '&').replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&nbsp;/g, ' ').replace(/&#39;/g, "'").replace(/&quot;/g, "'").replace(/<br>/g, '\n');
};
/**
 * html转义
 * @function
 * @param {String} str 字符串
 * @desc html_encode => encodeHtml
 */

export var encodeHtml = function encodeHtml(str) {
  if (!str || str.length === 0) {
    return '';
  }

  return str.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/'/g, '&quot;');
};
/**
 * 去除标签
 * @function
 * @param {String} str 字符串
 * @desc removeHTMLTag => removeTag
 */

export var removeTag = function removeTag(val) {
  if (val) {
    return val.replace(/(\n)/g, '').replace(/(\t)/g, '').replace(/(\r)/g, '').replace(/<\/?[^>]*>/g, '').replace(/\s*/g, '');
  }

  return '';
};
/**
 * 文本转成展示格式
 * @function
 * @param {String} text
 */

export var formatWrapTextOut = function formatWrapTextOut(text) {
  if (text) {
    return text.toString().replace(/<br\/>/g, '\n');
  }

  return text;
};
/**
 * 文本转成存储格式
 * @function
 * @param {String} text
 */

export var formatWrapTextIn = function formatWrapTextIn(text) {
  if (text) {
    return text.replace(/\r\n/g, '<br/>').replace(/\n/g, '<br/>').replace(/\s/g, ' ');
  }

  return text;
};